import { useState } from "react";
import logo from "../assets/logo.png";
import { Button, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { LogIn } from "lucide-react";
import { httpService } from "../httpService";
import { toast } from "react-toastify";
import { setAccessToken } from "../routes/tokenStore";

function HomePage() {
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);

  const loginAccount = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { data, error } = await httpService.post("login", user);

    if (data) {
      setAccessToken(data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);

      window.location.assign("/");
    }

    if (error) {
      localStorage.removeItem("refreshToken");
      toast.error(error);
    }
    // if (data) {

    //   // localStorage.setItem(
    //   //   process.env.REACT_APP_PROJECT_ACCOUNT,
    //   //   JSON.stringify(data)
    //   // );

    //   // window.location.assign(window.location.href);
    //   //toast.success();
    // }

    // if (error) {
    //   toast.error(error);
    // }
    setLoading(false);
  };
  return (
    <div>
      <div className="container">
        <div className="text-center mt-5">
          <img src={logo} alt="logo" height={100} className="mb-4" />
          <div className="text-center mb-4">
            <Typography variant="h5" fontWeight={700}>
              NMCN EXAMINER POSTING PORTAL
            </Typography>
          </div>
          <form onSubmit={loginAccount}>
            <div className="row d-flex justify-content-center">
              <div className="col-sm-4">
                <div className="mb-3">
                  <TextField
                    fullWidth
                    label="Email Address"
                    onChange={(e) =>
                      setUser({ ...user, emailAddress: e.target.value })
                    }
                  />
                </div>
                <div className="mb-3">
                  <TextField
                    fullWidth
                    type="password"
                    label="Password"
                    onChange={(e) =>
                      setUser({ ...user, password: e.target.value })
                    }
                  />
                </div>
                <div className="mb-3 text-center">
                  <LoadingButton
                    type="submit"
                    color="success"
                    variant="contained"
                    endIcon={<LogIn />}
                    fullWidth
                    loading={loading}
                    loadingPosition="end"
                  >
                    Login
                  </LoadingButton>
                </div>

                <div className="mb-2">
                  <Typography>
                    Don't have an account yet?
                    <Button
                      href="/createaccount"
                      sx={{ textTransform: "capitalize" }}
                    >
                      Create account
                    </Button>{" "}
                  </Typography>
                </div>
                <div className="mb-2">
                  <Button
                    color="error"
                    href="/forgotpassword"
                    sx={{ textTransform: "capitalize" }}
                  >
                    Forgot Password
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
